import { Component, ViewChild, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  InputComponent,
  RtInput,
  AvatarComponent,
  SelectComponent,
} from '@core/user-interface-legacy';

import type { UserSelectOption } from './user-select.types';

@Component({
  selector: 'rt-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SelectComponent, AvatarComponent, InputComponent, TranslatePipe],
})
export class UserSelectComponent extends RtInput<number | null> {
  public readonly options = input<UserSelectOption[]>([]);
  public readonly isDisabled = input<boolean>(undefined!);
  public readonly isReadOnly = input<boolean>(undefined!);
  public readonly isInvalid = input<boolean>(undefined!);
  public readonly isUserDeleted = input<boolean>(undefined!);

  @ViewChild('inputTrigger') public inputComponent: InputComponent;

  public clearInput(event: Event): void {
    if (!this.isDisabled() || !this.isReadOnly()) {
      event.preventDefault();
      event.stopPropagation();

      this.valueChange.emit(null);
    }
  }
}
